import { useMutation } from '@tanstack/react-query';
import APIClient from '@/services/APIClient';
import BaseServices from '@/services/BaseServices';
import { ReservationCancellationPayload } from '@/apiModels/SeatStatusPayload';

const useUpdateSeatStatus = ({
  cb,
  cbError,
  cbSuccess,
}: IMutationHookProps<ReservationCancellationPayload>) => {
  return useMutation<
    ReservationCancellationPayload,
    CustomError<RevelErrorResponse>,
    CancelSeatReservationRequest<ReservationCancellationPayload>
  >({
    mutationFn: ({ payload, eventId }) => {
      const apiClient = new APIClient<ReservationCancellationPayload>(
        BaseServices.SEAT_RESERVATION_SERVICE,
        `/user-app/admin/event/${eventId}/cancel-reservation`,
      );
      return apiClient.post<ReservationCancellationPayload>(payload);
    },
    onSuccess: cbSuccess,
    onError: cbError,
    onMutate: cb,
  });
};

export default useUpdateSeatStatus;
